// (Copyright) Confluent, Inc.

import styled, { type DefaultTheme } from 'styled-components';
import capsize from 'capsize';

import { FONT_METRICS, SF } from '../constants/typefaces';

export const fontBasedStyles =
  (stylesObj: Partial<Record<DefaultTheme['v1FontFamilyUsed'], string>>) =>
  (props: { theme: DefaultTheme }): string =>
    props.theme.v1FontFamilyUsed in stylesObj ? stylesObj[props.theme.v1FontFamilyUsed] : '';

export const capsizeStyles =
  (capConfig: { capHeight: number; lineGap: number }) => (props: { theme: DefaultTheme }) =>
    capsize({
      ...capConfig,
      fontMetrics: props.theme.v1FontFamilyUsed === SF ? FONT_METRICS.SF : FONT_METRICS.INTER,
    });

export const createCapBasedStyledComponent = (
  tag: any,
  capConfig: {
    capHeight: number;
    lineGap: number;
  }
) => {
  // @ts-expect-error - TS2769 - No overload matches this call.
  return styled(styled(styled(tag)(capsizeStyles(capConfig)))<any>`
    font-family: ${({ theme }) => theme.fonts.default};
    margin: 0;
  `);
};
